module.exports = __webpack_public_path__ + "static/map-help-walkthrough-7a51e8089778cd39a80d61e343208b23.gif";